import React from 'react';
import classnames from 'classnames';
// import Button from 'components/Button';

const Page = ({ active, number, onChange }) => {
	// Pass current number to parent's function
	const onClick = () => onChange({ name: 'page', value: number });

	const cls = classnames(
		'w-9 h-9 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors',
		+active !== number && 'text-neutral-600 dark:text-neutral-400',
		+active === number && 'text-neutral-800 bg-neutral-100 dark:text-white dark:bg-neutral-700'
	);

	return (
		<button
			className={cls}
			onClick={onClick}
		>
			{number}
		</button>
	);
};

export default Page;
